module.exports = __webpack_public_path__ + "img/photo-23.6fcdce8f.webp";